module.exports = __webpack_public_path__ + "media/images/gab-ai-logo-black-transparent-filled-02d029ce5c85af579b95a9ef8ccd69fb.svg";